import UserIcon from "../../assets/icons/user-profile.svg";
import SecurityIcon from "../../assets/icons/security.svg";
import NotificationsIcon from "../../assets/icons/notifications.svg";
import LogoutIcon from "../../assets/icons/logout.svg";
import AffiliatesIcon from "../../assets/icons/affiliates.svg";

export const statuses = [
  {
    id: 0,
    nameParam: "all",
  },
  {
    id: 1,
    nameParam: "active",
  },
  {
    id: 2,
    nameParam: "purchased",
  },
  {
    id: 3,
    nameParam: "expired(purchased)",
  },
  {
    id: 4,
    nameParam: "expired",
  },
];

export const profileSidebarItems = [
  {
    icon: UserIcon,
    label: "personal_details",
    value: "personal",
  },
  {
    icon: SecurityIcon,
    label: "security",
    value: "security",
  },
  {
    icon: NotificationsIcon,
    label: "notifications",
    value: "notifications",
  },
  {
    icon: AffiliatesIcon,
    label: "affiliates",
    value: "affiliates",
  },
  {
    icon: LogoutIcon,
    label: "logout",
    value: "logout",
  },
];

//for date picker
export const days = ["א", "ב", "ג", "ד", "ה", "ו", "ש"];
// Sunday א
// Monday ב
// Tuesday ג
// Wednesday ד
// Thursday ה
// Friday ו
// Saturday ש

export const months = [
  "ינואר",
  "פברואר",
  "מרץ",
  "אפריל",
  "מאי",
  "יוני",
  "יולי",
  "אוגוסט",
  "ספטמבר",
  "אוקטובר",
  "נובמבר",
  "דצמבר",
];

// ינואר January
// פברואר February
// מרץ March
// אפריל April
// מאי May
// יוני June
// יולי July
// אוגוסט August
// ספטמבר September
// אוקטובר October
// נובמבר November
// דצמבר December
